<template>
  <div>
    <forms-vue
      v-bind:title="title"
      v-bind:form="form"
      v-bind:submit_url="submit_url"
      v-bind:redirect_submit_url="redirect_submit_url"
      v-bind:edit_get_url="edit_get_url"
      v-bind:watch="watchers"
      v-bind:submit_in_url="submit_in_url"
    ></forms-vue>
  </div>
</template>
  <script type="text/javascript">
export default {
  data() {
    return {
      title: "Búsqueda",
      submit_url: "",
      redirect_submit_url: "Búsqueda",
      edit_get_url: "",
      submit_in_url: true,
      tipo_registro: "RE",
      watchers: [],
      form: [],
    };
  },
  created() {
    this.tipo_registro = this.$route.params.tipo;
    this.form = [
      [
        {
          col: "12",
          title: "Datos",
          footer: {},
          attrs: [
            [
              {
                pretty_name: "Tipo de Registro",
                name: "cali_tipo_nc_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
              },
              {
                pretty_name: "Creador",
                name: "creador_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
              },
            ],
            [
              {
                pretty_name: "Fecha Creación de Registron",
                name: "FechaCreacion",
                placeholder: "Desde",
                desc: "text",
                type: "title",
                extra: "",
                value: "",
              },
              {
                pretty_name: "Desde",
                name: "fecha_creacion_desde",
                placeholder: "Desde",
                desc: "text",
                type: "date",
                extra: "",
                value: "",
                cols: "6",
              },
              {
                pretty_name: "Hasta",
                name: "fecha_creacion_hasta",
                placeholder: "Hasta",
                desc: "text",
                type: "date",
                extra: "",
                value: "",
                cols: "6",
              },
            ],
            [
              {
                pretty_name: "Descripción",
                name: "descripcion_ficha",
                desc: "text",
                type: "text",
                extra: "",
                value: "",
                cols: "12",
              },
            ],

            [
              {
                pretty_name: "Proceso",
                name: "proceso_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
              },
              {
                pretty_name: "Clasificación",
                name: "clasificacion_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
              },
            ],
            [
              {
                pretty_name: "Cliente",
                name: "cliente_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
                ajax: {
                  url: this.$root.UrlBase("clientes/list/get"),
                  filter: "razon",
                  label: "razon",
                  code: "id",
                },
              },
              {
                pretty_name: "Proveedor",
                name: "proveedor_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "6",
                ajax: {
                  url: this.$root.UrlBase("proveedores/list/get"),
                  filter: "razon",
                  label: "razon",
                  code: "id",
                },
              },
            ],
            [
              {
                pretty_name: "Responsable Actual",
                name: "responsable_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "4",
              },
              {
                pretty_name: "Etapa Actual",
                name: "etapa_actual_id",
                desc: "select",
                type: "select",
                extra: "",
                value: "",
                options: [],
                cols: "4",
              },
              {
                pretty_name: "Estado Actual",
                name: "estado",
                desc: "select",
                type: "select",
                extra: {
                    multiple: true
                },
                value: "",
                options: [
                  { label: "En Proceso", code: "A" },
                  { label: "Finalizado", code: "C" },
                  { label: "Eliminado", code: "B" },
                ],
                cols: "4",
              },
              {
                pretty_name: "nc",
                name: "nc",
                desc: "hidden",
                type: "hidden",
                value: this.tipo_registro,
              },
            ],
          ],
          footer: {
            buttons: [
              {
                type: "button",
                text: "Cancelar",
                class: "btn btn-danger pull-left",
                route: "HomeSections",
              },
              {
                type: "submit",
                text: "Buscar",
                class: "btn btn-success pull-right",
                route: "HomeSections",
              },
            ],
          },
        },
      ],
    ];
    this.watchers = [
      {
        watch: "value.cali_tipo_nc_id",
        route: this.$root.UrlBase("selects/init-new"),
        select: ["0", "0", "3", "0"],
        model: "Proceso",
        where: {
          "cali_procesos.estado": "A",
        },
        attr: "cali_tipo_nc_id",
        code: "id",
        label: "descripcion",
      },
      {
        watch: "value.cali_tipo_nc_id",
        route: this.$root.UrlBase("selects/init-new"),
        select: ["0", "0", "3", "1"],
        model: "ClasificacionNC",
        where: {
          "cali_clasificacion_nc.estado": "A",
        },
        attr: "cali_tipo_nc_id",
        code: "id",
        label: "descripcion",
      },
      {
        watch: "value.cali_tipo_nc_id",
        route: this.$root.UrlBase("selects/init-new"),
        select: ["0", "0", "5", "1"],
        model: "FichasEtapaNC",
        where: {
          "cali_etapas_tipo_nc.estado": "A",
        },
        attr: "cali_tipos_nc_id",
        extra: { tipo_nc: this.tipo_registro },
        nc: this.tipo_registro,
        code: "id",
        label: "descripcion",
        concatena_descripcion: ["nodo_numer", "descripcion"],
      },

      {
        watch: "value.cali_tipo_nc_id",
        route: this.$root.UrlBase("nc/disables-beta"),
        select: ["0", "0", "4", "0"],
        model: "TipoNC",
        attr: [
          {
            model: "TipoNC",
            search: "id",
            attribute: "marca_clien_prove",
            deseado: ["A", "C"],
          },
        ],
        type: "disable",
      },
      {
        watch: "value.cali_tipo_nc_id",
        route: this.$root.UrlBase("nc/disables-beta"),
        select: ["0", "0", "4", "1"],
        model: "TipoNC",
        attr: [
          {
            model: "TipoNC",
            search: "id",
            attribute: "marca_clien_prove",
            deseado: ["P", "E", "A"],
          },
        ],
        type: "disable",
      },
    ];

    this.submit_url = this.$root.UrlBase("busqueda/reporte-beta");

    const data = {
      selects: {
        User2: {},
        generic2: {
          code: "id",
          label: "descripcion",
          model: "TipoNC",
          order: "descripcion",
          nc: this.tipo_registro,
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init-new"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.form[0][0].attrs[0][0].options = response.generic2;
        this.form[0][0].attrs[0][1].options = response.User2;
        this.form[0][0].attrs[5][0].options = response.User2;
      });
    if (this.$route.params && this.$route.params.tipo) {
      console.log(this.$route.params.tipo);
      switch (this.$route.params.tipo) {
        case "RE":
          this.title = "Busqueda Registro";
          break;
        case "NO":
          this.title = "Busqueda Información Documentada";
          this.form[0][0].attrs[4][0].type = "hidden";
          this.form[0][0].attrs[4][1].type = "hidden";
          break;
        case "AU":
          this.title = "Busqueda Auditoria";
          this.form[0][0].attrs[4][0].type = "hidden";
          this.form[0][0].attrs[4][1].type = "hidden";
          break;

        default:
          break;
      }
    }
  },
};
</script>

